module.exports = __webpack_public_path__ + "img/logo.3b01d310.png";